import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
} from '@mui/material';
import { colors } from '../../styles/colors';

const ConfirmDialog = ({
  open,
  onClose,
  onConfirm,
  title = 'Confirmer',
  message = 'Etes-vous sur de vouloir continuer ?',
  confirmLabel = 'Confirmer',
  cancelLabel = 'Annuler',
  severity = 'warning',
}) => {
  const confirmColor = severity === 'warning' ? colors.bordeaux : colors.primary;

  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="confirm-dialog-title"
      PaperProps={{
        sx: {
          borderRadius: '20px',
          backdropFilter: 'blur(16px)',
          background: colors.cardGlass,
          border: `1px solid ${colors.borderLight}`,
          maxWidth: 420,
          mx: 2,
        },
      }}
      BackdropProps={{
        sx: { backdropFilter: 'blur(4px)' },
      }}
    >
      <DialogTitle
        id="confirm-dialog-title"
        sx={{
          fontFamily: '"Playfair Display", Georgia, serif',
          fontSize: '1.3rem',
          fontWeight: 600,
          color: colors.charcoal,
          pb: 1,
        }}
      >
        {title}
      </DialogTitle>
      <DialogContent>
        <Typography
          sx={{
            fontFamily: '"DM Sans", sans-serif',
            fontSize: '0.95rem',
            color: colors.textMed,
            lineHeight: 1.6,
          }}
        >
          {message}
        </Typography>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2.5, gap: 1 }}>
        <Button
          onClick={onClose}
          variant="outlined"
          sx={{
            borderRadius: '100px',
            textTransform: 'none',
            fontFamily: '"DM Sans", sans-serif',
            fontWeight: 600,
            color: colors.textMed,
            borderColor: colors.border,
            '&:hover': {
              borderColor: colors.charcoal,
              bgcolor: 'rgba(0,0,0,0.03)',
            },
          }}
        >
          {cancelLabel}
        </Button>
        <Button
          onClick={() => {
            onConfirm();
            onClose();
          }}
          variant="contained"
          sx={{
            borderRadius: '100px',
            textTransform: 'none',
            fontFamily: '"DM Sans", sans-serif',
            fontWeight: 600,
            bgcolor: confirmColor,
            color: colors.white,
            '&:hover': {
              bgcolor: severity === 'warning' ? colors.bordeauxLight : colors.primaryLight,
            },
          }}
        >
          {confirmLabel}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmDialog;
